import { UserOutlined, ShopOutlined, BankOutlined } from "@ant-design/icons";
import { Empty, Modal, Spin, Tag } from "antd";
import { useEffect, useState } from "react";
import { getAccess } from "../../../api/login";
import { getUser, selectUserAccess, isSubSellerAccess } from "../../../helpers/user";
import "./AccountSelectionModal.scss";

const AccountSelectionModal = ({ open, onClose }) => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Helper to get data from seller or account
  const getAccessData = (access) => {
    const data = access?.seller || access?.account;
    return {
      id: data?.id,
      displayName: data?.display_name,
      type: data?.type,
      email: data?.email,
    };
  };

  // Get account type label
  const getAccountTypeLabel = (type) => {
    if (!type) return null;
    if (type.includes("PJ") || type.includes("business")) return "Empresa";
    if (type.includes("PF") || type.includes("individual")) return "Pessoa";
    return type;
  };

  // Get icon based on account type
  const getAccountIcon = (type) => {
    if (type?.includes("PJ") || type?.includes("business")) return <ShopOutlined />;
    if (type?.includes("PF") || type?.includes("individual")) return <UserOutlined />;
    return <BankOutlined />;
  };

  useEffect(() => {
    const loadAccounts = async () => {
      const user = getUser();
      if (user) {
        setLoading(true);
        try {
          const data = await getAccess(user.id);
          const results = (data.results || []).filter(
            (item) => !isSubSellerAccess(item)
          );
          // Sort by created_at, oldest first
          results.sort((a, b) => {
            const dataA = a?.seller || a?.account;
            const dataB = b?.seller || b?.account;
            const dateA = new Date(a?.created_at || dataA?.created_at || 0);
            const dateB = new Date(b?.created_at || dataB?.created_at || 0);
            return dateA - dateB;
          });
          setAccounts(results);
        } catch (error) {
          console.error("Error loading accounts", error);
        } finally {
          setLoading(false);
        }
      }
    };

    if (open) {
      loadAccounts();
    }
  }, [open]);

  const handleSelectAccount = (access) => {
    selectUserAccess(access);
    window.location.href = "/";
  };

  const renderAccountCard = (access) => {
    const data = getAccessData(access);

    return (
      <div
        key={data.id}
        className="account-card"
        onClick={() => handleSelectAccount(access)}
      >
        <div className="account-icon">{getAccountIcon(data.type)}</div>
        <div className="account-info">
          <h4 className="account-name">{data.displayName}</h4>
          <div className="account-details">
            {data.type && (
              <Tag color="blue" className="type-tag">
                {getAccountTypeLabel(data.type)}
              </Tag>
            )}
          </div>
          {data.email && <span className="account-email">{data.email}</span>}
        </div>
      </div>
    );
  };

  return (
    <Modal
      title="Selecionar Conta"
      open={open}
      onCancel={onClose}
      centered
      footer={null}
      width={600}
      className="account-selection-modal"
    >
      <div className="account-selection-content">
        {loading ? (
          <div className="loading-container">
            <Spin size="large" />
          </div>
        ) : accounts.length === 0 ? (
          <Empty description="Nenhuma conta disponivel" />
        ) : (
          <div className="accounts-grid">
            {accounts
              .filter((access) => getAccessData(access).id)
              .map((access) => renderAccountCard(access))}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AccountSelectionModal;
